import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "live-cards",
  name: "直播卡片",
  icon: "卡",
  group: "国学组件",
  description: "准准风首页横向直播卡片，展示直播状态、主播和在线人数。",
  defaultProps: {
    "title": "在线直播",
    "subtitle": "在线连麦实时沟通",
    "moreText": "更多",
    "moreLink": "/pages/guoxue/live",
    "limit": 2,
    "items": []
}
}
